/**
 * @desc 创建供应商账号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierAccountRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
